export enum MultiFactorCodeValidationStates {
  hide,
  valid,
  invalid,
}
